window.addEventListener("DOMContentLoaded", () => {
   class Accordion extends HTMLElement {
      constructor() {
         super();
         this.toggler = this.querySelector("[accordion-toggler]");
         this.content = this.querySelector("[accordion-content]");
   
         this.toggler.addEventListener("click", () => {
            if (this.className.includes("active")) {
               this.content.style = null;
            }
            else {
               this.content.style.height = this.content.scrollHeight + "px";
            }
            this.classList.toggle("active");
         })
      }
   }
   customElements.define('accordion-element', Accordion);
})